import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { SharedComponents } from '../../../components/shared.module';
import { ProjectService } from '../../../core/services/project/project.service';
import { RestService } from '../../../core/services/rest.service';
import { ToasterService } from '../../../core/services/toaster-service';
import { MaterialModule } from '../../../core/shared/material.module';
import { releaseDropdownConfig } from '../../../core/table-templates/schedule-table';
import { MessageEnum } from '../../../core/utils/message.enum';

@Component({
  selector: 'app-test-schedule-relase',
  standalone: true,
  imports: [MaterialModule, MatIconModule, SharedComponents, CommonModule],
  templateUrl: './test-schedule-relase.component.html',
  styleUrl: './test-schedule-relase.component.scss'
})
export class TestScheduleRelaseComponent implements OnInit {
  projectId: any = '';
  @Input()
  data: { title?: string } = {};
  activeModal = inject(NgbActiveModal);
  selectedRelease: string = "";
  relaseConfig = releaseDropdownConfig;
  private messageService = inject(MessageService);
  releaseOptions: any = [
    {
      label: "",
      options: []
    }
  ]
  isOptionsLoaded = false;
  
  ngOnInit(): void {
    this.restService.getReleases(this.projectId).subscribe((response) => {
      this.isOptionsLoaded = true;
      response?.data?.forEach((option: any) => {
        this.releaseOptions[0].options.push({
          label: option.name,
          value: option.id
        });
      })
    }, (error) => {
      this.isOptionsLoaded = true;
      this.toaster.pop({ type: 'error', text: MessageEnum.RELEASE_LOAD_FAILURE });
    });
  }
  constructor(
    private restService: RestService,
    private projectService: ProjectService,
    private readonly toaster: ToasterService
  ) {
    this.projectService.getProjectId().subscribe((id) => {
      this.projectId = id;
    });
  }

  closePopup() {
    this.activeModal.dismiss('Cross click');
  }
  save() {
    this.activeModal.close(this.selectedRelease);
  }
  updateRelease(event: any) {
    this.selectedRelease = event.value;
  }
}
